import api from "../../api";
import { serverPath } from "../../config";

const PAGE_SIZE = 10;

export const getCommunity = async (page = 0, searchQuery = "") => {
  const { data } = await api.post(`${serverPath.communityList}?pageNumber=${page}&size=${PAGE_SIZE}`, {
    fieldsName: ["firstName", "lastName"],
    value: searchQuery,
    orderby: "userId",
    order: "DESC",
    status: "ONLINE",
  });

  return { data: data.content || [], nextPage: page + 1, totalPages: data.totalPages };
};

export const getCommunityCount = () => api.get(serverPath.communityCount);
